import { useEffect, useState } from 'react';

const SOFIA_TIME_ZONE = 'Europe/Sofia';
const TIME_PLACEHOLDER = '--:--';

const createTimeFormatter = (timeZone?: string) =>
  new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    hour12: true,
    minute: '2-digit',
    timeZone,
  });

function getDelayUntilNextMinute(now: Date) {
  return (60 - now.getSeconds()) * 1000 - now.getMilliseconds() + 10;
}

export function useSofiaTime() {
  // Keep first SSR + CSR paint stable to avoid hydration mismatches.
  const [timeLabel, setTimeLabel] = useState(TIME_PLACEHOLDER);

  useEffect(() => {
    const sofiaFormatter = createTimeFormatter(SOFIA_TIME_ZONE);
    const localFormatter = createTimeFormatter();

    const formatTimeLabel = (date: Date) => {
      try {
        return sofiaFormatter.format(date);
      } catch {
        return localFormatter.format(date);
      }
    };

    const updateNow = () => {
      setTimeLabel(formatTimeLabel(new Date()));
    };

    updateNow();

    let intervalId: ReturnType<typeof setInterval> | undefined;

    const timeoutId = setTimeout(() => {
      updateNow();

      intervalId = setInterval(() => {
        updateNow();
      }, 60_000);
    }, getDelayUntilNextMinute(new Date()));

    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  return timeLabel;
}
